export default "__VITE_PUBLIC_ASSET__8adb113e__"